module.exports = __webpack_public_path__ + "img/nav-logo-1.7fdfbaea.svg";